import script from "./TooltipButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipButton.vue?vue&type=script&setup=true&lang=js"

import "./TooltipButton.vue?vue&type=style&index=0&id=579cdc88&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marcin\\Local Sites\\doktorku\\app\\public\\wp-content\\themes\\doktorku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-579cdc88"]])

export default __exports__